import { __rest } from '../_virtual/_tslib.js';
import { useState, useEffect } from 'react';
import { subscribeMatchMedia } from '../methods/browser.js';

const useMediaQuery = (_a) => {
    var { queryType, initialState = false } = _a, props = __rest(_a, ["queryType", "initialState"]);
    const { sizePx } = props;
    let query = "";
    switch (queryType) {
        case "max-width":
            query = `(max-width: ${sizePx}px)`;
            break;
        case "min-width":
            query = `(min-width: ${sizePx}px)`;
            break;
        case "max-height":
            query = `(max-height: ${sizePx}px)`;
            break;
        case "min-height":
            query = `(min-height: ${sizePx}px)`;
            break;
        case "mobile":
            query = `(max-width: 576px)`;
            break;
        case "medium-screen":
            query = `(max-width: 991px)`;
            break;
        case "desktop":
            query = `(min-width: 992px)`;
            break;
    }
    // Keep SSR and first client render aligned — read viewport only after mount.
    const [matches, setMatches] = useState(initialState);
    useEffect(() => {
        if (!query || typeof window === "undefined") {
            return;
        }
        const media = window.matchMedia(query);
        const listener = () => setMatches(media.matches);
        setMatches(media.matches);
        return subscribeMatchMedia(media, listener);
    }, [query]);
    return matches;
};

export { useMediaQuery as default };
//# sourceMappingURL=useMediaQuery.js.map
